import * as React from 'react'

import CreditImageURL from './assets/credit.png'
import * as styles from './ImageAsset.css'

export enum ImageAssetType {
  CREDIT = 'Made by ennoshita'
}

interface ImageAssetProps {
  type: ImageAssetType
}

const ImageAsset: React.FunctionComponent<ImageAssetProps> = ({ type }) => {
  let src
  let content

  switch (type) {
    case ImageAssetType.CREDIT:
      src = CreditImageURL
      break
    default:
      src = ''
      break
  }
  content = <img className={styles.image} src={src} alt={type} />
  return content
}

export default ImageAsset
